<template>
    <div>
        <transition name="slither">
            <router-view></router-view>
        </transition>
        <notifications group="not" />
    </div>
</template>

<script>
export default {};
</script>

<style>
.slither-enter-active, .slither-leave-active {
    transition: transform 0.5s;
}

.slither-enter, .slither-leave-to {
    transform: translateX(100%);
}

.slither-enter-to, .slither-leave {
    transform: translateX(0);
}
</style>
